<template>
  <div id="app">
    <router-view/>
    <div style="padding: 20px;text-align: center;border-top: 1px solid #DDDDDD;margin-top: 20px;">© Copyright 2021. 南京瓦丁科技有限公司 版权所有 | 地址:南京市江宁区庄排路157号双登研究院4楼 | 苏ICP备13004818号-1</div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue